let bridge = null;
export function registerOfferCalculator(api) {
    bridge = api;
    window.offerCalculator = api;
}
export function unregisterOfferCalculator() {
    bridge = null;
    delete window.offerCalculator;
}
export function getOfferCalculatorBridge() {
    return bridge;
}
